import React from "react";

const BillingPage = () => (
  <div className="min-h-screen w-full flex bg-[#F6F7F9] dark:bg-gray-900">
    <main className="flex-1 min-h-screen bg-white dark:bg-gray-900 p-10 transition-colors duration-250">
      <h2 className="text-base font-semibold text-slate-800 dark:text-white mb-5">Billing</h2>
      <div className="text-slate-500 dark:text-gray-200">Billing details and payment methods will be shown here.</div>
    </main>
  </div>
);

export default BillingPage;
